module.exports = __webpack_public_path__ + "img/et.d0ca475e.svg";